import {Avatar, Button, closeDialog, openDialog} from 'platform/components';
import {HStack, Show, VStack} from 'platform/foundation';

import {useEffect, useState} from 'react';

import {isNotNil} from 'ramda';

import {useGetCurrentUserInfoQuery, useGetUserAvatarUrlQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {UploadAvatar} from './UploadAvatar';

const UPLOAD_AVATAR_DIALOG_ID = 'upload-avatar';
interface PersonalInformationAvatarProps extends RequiredTestIdProps {
  setFileId: (fileId: string | null) => void;
  fileId: string | null;
}

export function PersonalInformationAvatar(props: PersonalInformationAvatarProps) {
  const {data: user} = useGetCurrentUserInfoQuery();
  const {data: url} = useGetUserAvatarUrlQuery(
    {userId: user?.id ?? '', height: 240, width: 240},
    {skip: !user?.id}
  );

  const [avatarUrl, setAvatarUrl] = useState<string | Nullish>(null);
  useEffect(() => setAvatarUrl(url), [url]);

  const handleUploadAvatar = () =>
    openDialog(
      <UploadAvatar
        data-testid={suffixTestId('upload-photo', props)}
        handleUpload={({id, url}) => {
          props.setFileId(id);
          setAvatarUrl(url);
          closeDialog(UPLOAD_AVATAR_DIALOG_ID);
        }}
      />,
      {title: i18n.t('general.actions.upload'), id: UPLOAD_AVATAR_DIALOG_ID}
    );

  const handleDiscardChanges = () => {
    props.setFileId(null);
    setAvatarUrl(url);
  };

  return (
    <VStack spacing={2} align="center">
      <Avatar imageUrl={avatarUrl} size="large" data-testid={suffixTestId('avatar', props)} />

      <HStack spacing={2}>
        <Button
          leftIcon="image/edit"
          variant="link"
          title={i18n.t('entity.person.actions.uploadPhoto')}
          onClick={handleUploadAvatar}
          data-testid={suffixTestId('upload-photo', props)}
        />

        <Show when={isNotNil(props.fileId)}>
          <Button
            leftIcon="navigation/refresh"
            variant="dangerLink"
            title={i18n.t('general.actions.discardChanges')}
            onClick={handleDiscardChanges}
            data-testid={suffixTestId('discard-changes', props)}
          />
        </Show>
      </HStack>
    </VStack>
  );
}
